<template>
  <!-- <CustomFilter
    v-model="valueModel"
    :options="platforms"
    input-name="platforms"
    :label="label"
    :all-placeholder="
      this.$t(
        '_web_competitions_tournaments-list-all-platforms',
        'All platforms'
      )
    "
    clear-if-selected-all
  /> -->
  <AutoSuggest
    v-model="valueModel"
    class="mb-4 platforms-filter"
    :label="label"
    multiple
    only-unique
    :source="platforms"
    name="platforms"
    :placeholder="
      this.$t(
        '_web_competitions_tournaments-list-all-platforms',
        'All platforms'
      )
    "
    display-property="name"
    :show-on-focus="true"
  />
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { prop } from '@/utils/factories';
// import CustomFilter from '@/components/form/MultiSelectBox';
import AutoSuggest from '@/components/molecules/form/autoComplete/HeraAutosuggest.vue';

export default {
  components: {
    // CustomFilter,
    AutoSuggest,
  },

  props: {
    value: prop(Array),
    label: prop(String),
  },

  computed: {
    ...mapGetters(['platforms']),
    valueModel: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue.map(platform => platform.id));
      },
    },
  },

  created() {
    this.fetchPlatforms();
  },

  methods: {
    ...mapActions(['fetchPlatforms']),
  },
};
</script>

<style lang="scss"></style>
